import actions from './actions'

export default function InventoryServiceLaborsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_INVENTORYSERVICELABOR:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_INVENTORYSERVICELABOR:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_INVENTORYSERVICELABOR:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_INVENTORYSERVICELABOR:
      return {
        ...state,
        editing: { laborID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_INVENTORYSERVICELABOR_RECIEVED ||
      actions.UPDATE_INVENTORYSERVICELABOR_RECIEVED ||
      actions.DELETE_INVENTORYSERVICELABOR_RECIEVED:
      return {
        ...state,
        editing: { laborID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
